export default{

    methods:{
        dateIsBeforeToday(dt){
            var today = new Date()
            var tocheck = new Date(dt)
           // console.log(today + ' ' + today.getDate() )
            //console.log(tocheck + ' ' + tocheck.getDate())
            return tocheck.getDate() < today.getDate()
        },
        daysBetweenDates(date1, date2){
            const ONE_DAY = 1000 * 60 * 60 * 24
            var d1 = new Date(date1) 
            var d2 = new Date(date2)
            var days = (d2 - d1 )/ONE_DAY
            return days
        },
        datesMatch(date1,date2){
            var d1=new Date(date1)
            var d2=new Date(date2)
            var match = d1.getTime()===d2.getTime()
            return match
        },
        comparableTime(time){
            return new Date('1/1/1970 ' + time);
        },
        AddDate(oldDate, offset, offsetType) {
            var year = parseInt(oldDate.getFullYear());
            var month = parseInt(oldDate.getMonth());
            var date = parseInt(oldDate.getDate());
            var hour = parseInt(oldDate.getHours());
            var newDate;

            switch (offsetType) {
                case "Y":
                case "y":
                    newDate = new Date(year + offset, month, date, hour);
                    break;
            
                case "M":
                case "m":
                    var yearOffset = 0;
                    var monthOffset = 0;
                    if (offset <12)
                        {
                            yearOffset = Math.floor((month + offset)/12);
                            monthOffset = (month + offset)%12;
                        }
                    else
                        {
                            yearOffset = Math.floor(offset/12);
                            monthOffset = month%12 + offset%12;
                        }
                    newDate = new Date(year + yearOffset, month + monthOffset, date, hour);
                    break;
            case "D":
            case "d":
                var o = oldDate.getTime();
                var n = o + offset * 24 * 3600 * 1000;
                newDate = new Date(n);
                break;
            
            case "H":
            case "h":
                var o = oldDate.getTi();
                var n = o + offset * 3600 * 1000;
                newDate = new Date(n);
                break;
            default:
                newDate = new Date(year + offset, month, date, hour);
            }
            return newDate;
        }

    }


}